module.exports = __webpack_public_path__ + "img/masks/mask-jacek.svg";